import { createHeroView, createNavigationView } from './index'
import { ACCOUNT_TYPE_CORPORATE, VIEW_EMPLOYER } from '../constants'

const createRegistrationFormView = id => () => import('../views/CreateRegistrationFormView').then(m => m.default(id))
const Login = () => import('../components/Auth/Login.vue')
const LoginForm = () => import('../components/Auth/LoginForm.vue')
const ForgotPassword = () => import('../components/Auth/ForgotPassword.vue')
const ResetPassword = () => import('../components/Auth/ResetPassword.vue')
const ActivateAccount = () => import('../components/Auth/ActivateAccount.vue')

export const routes = () => [
  { path: '/bejelentkezes', redirect: '/belepes' },
  { path: '/bejelentkezes/maganszemely', redirect: '/belepes/maganszemely' },
  { path: '/bejelentkezes/maganszemely/munkaado', redirect: '/belepes/maganszemely/munkaado' },
  { path: '/bejelentkezes/ceg', redirect: '/belepes/ceg' },
  {
    path: '/belepes',
    components: {
      default: Login,
      hero: createHeroView('login'),
      navigation: createNavigationView()
    },
    meta: {
      pageTitle: 'Login'
    }
  },
  {
    path: '/belepes/maganszemely',
    components: {
      default: LoginForm,
      hero: createHeroView('login-private'),
      navigation: createNavigationView()
    },
    meta: {
      pageTitle: 'Login - Advertiser'
    }
  },
  {
    path: '/belepes/maganszemely/munkaado',
    components: {
      default: LoginForm,
      hero: createHeroView('login-private-employer'),
      navigation: createNavigationView()
    },
    props: {
      default: {
        view: VIEW_EMPLOYER
      }
    },
    meta: {
      pageTitle: 'Login - Private Employer'
    }
  },
  {
    path: '/belepes/ceg',
    components: {
      default: LoginForm,
      hero: createHeroView('login-corporate'),
      navigation: createNavigationView()
    },
    props: {
      default: {
        accountType: ACCOUNT_TYPE_CORPORATE,
        view: VIEW_EMPLOYER
      }
    },
    meta: {
      pageTitle: 'Login - Company'
    }
  },
  {
    path: '/regisztracio/maganszemely',
    components: {
      default: createRegistrationFormView('private'),
      hero: createHeroView('registration-private'),
      navigation: createNavigationView()
    },
    meta: {
      pageTitle: 'Signup - Private Entity'
    }
  },
  {
    path: '/regisztracio/ceg',
    components: {
      default: createRegistrationFormView('corporate'),
      hero: createHeroView('registration-corporate'),
      navigation: createNavigationView()
    },
    meta: {
      pageTitle: 'Signup - Company'
    }
  },
  {
    path: '/elfelejtett-jelszo',
    components: {
      default: ForgotPassword,
      hero: createHeroView('forgot-password'),
      navigation: createNavigationView()
    },
    meta: {
      pageTitle: 'Forgot Password'
    }
  },
  {
    path: '/jelszocsere/:email?/:token?',
    components: {
      default: ResetPassword,
      hero: createHeroView(),
      navigation: createNavigationView()
    },
    props: {
      default: true
    },
    meta: {
      pageTitle: 'Set New Password'
    }
  },
  {
    path: '/fiok-aktivalasa/:email/:token',
    components: {
      default: ActivateAccount,
      hero: createHeroView(),
      navigation: createNavigationView()
    },
    props: {
      default: true
    },
    meta: {
      pageTitle: 'Signup Activation'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/auth.js